<template>
  <sweet-table url="/erp/pay/money/query/receipt/report" :is-page="false" ref="table"
               :before-table-binding="beforeTableBinding"
               :query-form="dataForm" :summariesColumn="['totalAmount','payAmount','unPayAmount']" :height="500">
    <el-table-column prop="sellerName" label="销售方" header-align="center"
                     align="center"  :show-overflow-tooltip="true" :formatter="$c.companyNameFormat"></el-table-column>
    <el-table-column prop="code" label="发票号" header-align="center"
                     align="center"></el-table-column>
    <el-table-column prop="totalAmount" label="发票金额" header-align="center"
                     align="center" width="100"></el-table-column>
    <el-table-column prop="payAmount" label="已付款" header-align="center"
                     align="center" min-width="90">
    </el-table-column>
    <el-table-column prop="unPayAmount" label="未付款" header-align="center"
                     align="center" min-width="90"></el-table-column>
  </sweet-table>
</template>

<script>
import BigNumber from 'bignumber.js'
import SettleReportMixin from '@/views/modules/settle/report/SettleReportMixin'

export default {
  name: 'money',
  mixins: [SettleReportMixin],
  props: {
    orderId: ''
  },
  data () {
    return {
      dataForm: {
        orderId: '',
        receiptType: '产品'
      }
    }
  },
  watch: {
    orderId: {
      handler: function (newVal) {
        if (!newVal) {
          this.$refs.table.dataList = []
          return
        }
        this.dataForm.orderId = newVal
        this.$nextTick(() => {
          this.$refs.table.reload()
        })
      },
      immediate: true
    }
  },
  methods: {
    beforeTableBinding (dataList) {
      dataList.forEach(item => {
        let totalAmount = new BigNumber(item.totalAmount)
        item.totalAmount = totalAmount.toFixed(2)
        item.unPayAmount = totalAmount.minus(item.payAmount || 0).toFixed(2)
      })
    },
  }
}
</script>

<style scoped>

</style>
